/* eslint-disable */

import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';

declare global {
  interface Window {
    env: any;
  }
}

type EnvType = {
  API_URL: string;
  [EnvironmentVariable.Environment]: 'local' | 'testing' | 'prod';
  [EnvironmentVariable.SentryDsn]: string;
  [EnvironmentVariable.FindBranchLink]: string;
  [EnvironmentVariable.CuroContactPhoneNumber]: string;
  [EnvironmentVariable.CuroInformationPhoneNumber]: string;
  [EnvironmentVariable.CuroAppStoreLink]: string;
  [EnvironmentVariable.CuroGooglePlayLink]: string;
  [EnvironmentVariable.GoogleAnalyticsId]: string;
  [EnvironmentVariable.GoogleMapsApiKey]: string;
  [EnvironmentVariable.GoogleMapsID]: string;
  [EnvironmentVariable.GoogleReCaptchaSiteKey]: string;
};

export const envs: EnvType = { ...process.env, ...window.env };
